/**
 * Licensed Materials - Property of IBM
 * IBM Cognos Products: Collaboration
 * (C) Copyright IBM Corp. 2017, 2019
 *
 * US Government Users Restricted Rights - Use, duplication or disclosure
 * restricted by GSA ADP Schedule Contract with IBM Corp.
 */

define('collaboration/glass/controllers/ShareController',['../../lib/@waca/baglass/js/baglass/app/NavbarButtonSlideoutController', '../../api/sharing/ShareableItems', '../utils/GlassUtil'], function (NavbarButtonSlideoutController, ShareableItems, GlassUtil) {
	'use strict';

	function itemsToFeatures(items, features) {
		items.forEach(function (e) {
			features.push(GlassUtil.map.current[e.id]);
			if (e.items) {
				itemsToFeatures(e.items, features);
			}
		});
	}

	var ShareController = NavbarButtonSlideoutController.extend({

		init: function init() {
			ShareController.inherited('init', this, arguments);
			// this option is to let glass create one panel view per application view
			this.isAppviewScope = true;
			this.shareableItems = new ShareableItems();
			this.embedVisible = false;
			this.imageVisible = false;
		},

		onRender: function onRender(context) {
			this.shareableItems.setLogger(context);
			var button = context.target.plugin,
			    perspective = button.appView.perspective,
			    sharePerspectives = button.itemSpec.options.sharePerspectives,
			    embedPerspectives = button.itemSpec.options.embedPerspectives,
			    imagePerspectives = button.itemSpec.options.imagePerspectives,
			    features = [];

			itemsToFeatures(button.itemSpec.items || [], features);

			if (features.length && sharePerspectives.indexOf(perspective) !== -1) {
				button.show();
			} else {
				button.hide();
			}

			this.embedVisible = embedPerspectives.indexOf(perspective) !== -1;
			this.imageVisible = imagePerspectives.indexOf(perspective) !== -1;
			this.features = features;
		},

		/**
   * A callback that is called after the slideout opens.
   * @override
   */
		onShowCallback: function onShowCallback(context, slideout) {
			slideout.content.embedVisible = this.embedVisible;
			slideout.content.imageVisible = this.imageVisible;
			slideout.content.features = this.features;
			this.shareableItems.enterShareState({
				glassContext: context.glassContext,
				slideout: slideout
			});
		},

		/**
   * A callback that is called after the slideout hides.
   * @override
   */
		onHideCallback: function onHideCallback(context, slideout) {
			this.shareableItems.leaveShareState({
				glassContext: context.glassContext,
				slideout: slideout
			});
		}

	});

	return ShareController;
});
;

var _temp = function () {
	if (typeof __REACT_HOT_LOADER__ === 'undefined') {
		return;
	}
}();

;

